import PubSub from 'pubsub-js';
import { EVENT } from '../config/constants';
import canUseDOM from './canUseDOM';

class EventHandler {
  constructor() {
    if (!canUseDOM) {
      return;
    }

    this.body = document.body;
    this.scrollObject = {};
    this.resizeObject = {};
    this.lastScrollTop = 0;
    this.searchLastScrollTop = 0;
    this.bodyOffset = 0;

    // Handle Scroll Event
    window.addEventListener(
      'scroll',
      e => {
        this.bodyOffset = this.body.offsetTop - (window.scrollY || window.pageYOffset);
        if (this.bodyOffset === 0) {
          return;
        }
        this.scrollObject = {
          time: e.timeStamp,
          scrollY: -this.bodyOffset,
          // scrollX: this.bodyOffset.left,
          direction: this.lastScrollTop > -this.bodyOffset ? 'down' : 'up'
        };

        this.lastScrollTop = -this.bodyOffset;

        PubSub.publish(EVENT.SCROLL, this.scrollObject);
      },
      {
        capture: false,
        passive: true
      }
    );

    // Handle Resize Event
    window.addEventListener('resize', e => {
      this.resizeObject = {
        time: e.timeStamp,
        width: window.innerWidth,
        height: window.innerHeight,
        outerWidth: window.outerWidth,
        outerHeight: window.outerHeight
      };

      PubSub.publish(EVENT.RESIZE, this.resizeObject);
    });

    window.addEventListener('keydown', e => {
      PubSub.publish(EVENT.KEYDOWN, e);
      document.body.classList.remove('using-mouse');
    });

    window.addEventListener('mousedown', () => {
      document.body.classList.add('using-mouse');
    });

    this.searchScrollListener = this.searchScrollListener.bind(this);
    this.searchScrollHandler = this.searchScrollHandler.bind(this);
  }

  subscribe(event, info) {
    return PubSub.subscribe(event, info);
  }

  unsubscribe(token) {
    return PubSub.unsubscribe(token);
  }

  searchScrollListener(e) {
    const searchOverlayWrapper = document.getElementById('searchOverlayWrapper');
    const searchOverlayOffset = searchOverlayWrapper.getBoundingClientRect();
    const bodyOffset = document.body.offsetTop - (window.scrollY || window.pageYOffset);
    this.scrollObject = {
      time: e.timeStamp,
      scrollY: -searchOverlayOffset.top,
      scrollX: searchOverlayOffset.left,
      direction: this.searchLastScrollTop > -searchOverlayOffset.top ? 'down' : 'up'
    };
    this.lastScrollTop = -bodyOffset;

    if (Math.abs(Math.abs(this.searchLastScrollTop) - Math.abs(searchOverlayOffset.top)) > 50) {
      this.searchLastScrollTop = -searchOverlayOffset.top;
      PubSub.publish(EVENT.SCROLL, this.scrollObject);
    }
  }

  searchScrollHandler(isOpen) {
    const searchOverlay = document.getElementById('searchOverlay');
    if (isOpen) {
      searchOverlay.addEventListener('scroll', this.searchScrollListener);
    } else {
      searchOverlay.removeEventListener('scroll', this.searchScrollListener);
    }
  }
}

export default new EventHandler();
